export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`],
  [`Грудь`, `46`, `48`, `50`, `52`, `54`],
  [`Длина`, `63`, `65`, `67`, `69`, `71`]
];
